module.exports = __webpack_public_path__ + "static/media/meal.50f65b4a.png";